require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./klamath-county-gender-specific-supervision.json") })
        }
      }, "path---klamath-county-gender-specific-supervision");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---klamath-county-gender-specific-supervision!./.cache/json/klamath-county-gender-specific-supervision.json
// module id = 916
// module chunks = 231608221292675